import { UsersIcon } from '@phosphor-icons/react'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useGetVisitorAnalytics } from '@/api/visitors/get-visitor-analytics'
import { Icon } from '@/components/ui/icon'
import { Select } from '@/components/ui/select'
import { Typography } from '@/components/ui/typography'
import { selectActiveBuilding } from '@/reducers/buildingSelectorReducer'

import { DEFAULT_PERIOD, getPeriodOptions } from './visitors-analytics.constants'
import * as S from './visitors-analytics.styled'

export const VisitorsAnalytics = () => {
  const { t } = useTranslation(['visitors'])
  const [period, setPeriod] = useState(DEFAULT_PERIOD)
  const periodOptions = useMemo(() => getPeriodOptions(t), [t])

  const building = useSelector(selectActiveBuilding)

  const { data, isLoading } = useGetVisitorAnalytics({ buildingId: building?.id, period })

  return (
    <S.Wrapper $isLoading={isLoading}>
      <S.Row>
        <S.MetricsBox>
          <S.MetricItem>
            <S.MetricLabelRow>
              <Icon icon={UsersIcon} size={16} color="primary600" />
              <Typography size="text-small" color="primary600">
                {t('visitors:dashboard.analytics.totalAuthorizedVisitors')}
              </Typography>
            </S.MetricLabelRow>
            <Typography size="heading-huge" color="black800">
              {data?.visitors ?? 0}
            </Typography>
          </S.MetricItem>

          <S.MetricDivider />

          <S.MetricItem>
            <S.MetricLabelRow>
              <Icon icon={UsersIcon} size={16} color="primary600" />
              <Typography size="text-small" color="primary600">
                {t('visitors:analytics.checkIns')}
              </Typography>
            </S.MetricLabelRow>
            <Typography size="heading-huge" color="black800">
              {data?.checkIns ?? 0}
            </Typography>
          </S.MetricItem>
        </S.MetricsBox>

        <S.PeriodWrapper>
          <Select
            size="small"
            options={periodOptions}
            value={period}
            onChange={(value) => setPeriod(value)}
          />
        </S.PeriodWrapper>
      </S.Row>
    </S.Wrapper>
  )
}
